function gridParams(grid, url) {
    const filtering = grid.dataset.fieldNotesFiltering === '1';
    const pagination = grid.dataset.fieldNotesPagination === '1';

    return {
        category: filtering ? url.searchParams.get('category') || '' : '',
        page: pagination ? url.searchParams.get('page') || '1' : '1',
        rows: grid.dataset.fieldNotesRows || '2',
        filtering: filtering ? '1' : '0',
        pagination: pagination ? '1' : '0',
        base_url: url.toString(),
    };
}

function endpointUrl(params) {
    const restUrl = window.pageData?.fieldNotesRestUrl;

    if (!restUrl) {
        return null;
    }

    const url = new URL(restUrl, window.location.origin);

    Object.entries(params).forEach(([key, value]) => {
        url.searchParams.set(key, value);
    });

    return url;
}

function setLoading(grid, isLoading) {
    grid.classList.toggle('is-loading', isLoading);
    grid.setAttribute('aria-busy', isLoading ? 'true' : 'false');
}

function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function scrollToSection(grid) {
    const target = grid.closest('.section') || grid;

    target.scrollIntoView({
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start',
    });
}

async function refreshGrid(grid, targetUrl) {
    const restUrl = endpointUrl(gridParams(grid, targetUrl));

    if (!restUrl) {
        return null;
    }

    setLoading(grid, true);

    try {
        const response = await fetch(restUrl.toString(), {
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
            },
        });

        if (!response.ok) {
            return null;
        }

        const payload = await response.json();

        if (!payload?.html) {
            return null;
        }

        const template = document.createElement('template');

        template.innerHTML = payload.html.trim();

        const nextGrid = template.content.firstElementChild;

        if (!nextGrid) {
            return null;
        }

        grid.replaceWith(nextGrid);
        return nextGrid;
    } catch (error) {
        console.warn('Unable to refresh Field Notes grid.', error);
        return null;
    } finally {
        if (grid.isConnected) {
            setLoading(grid, false);
        }
    }
}

async function refreshAll(targetUrl) {
    const grids = Array.from(document.querySelectorAll('[data-field-notes-grid]'));

    if (grids.length === 0) {
        return false;
    }

    const results = await Promise.all(
        grids.map((grid) => refreshGrid(grid, targetUrl))
    );

    return results.every((grid) => grid instanceof Element);
}

function handleClick(event) {
    const link = event.target.closest('[data-field-notes-link]');

    if (
        !link
        || event.defaultPrevented
        || event.button !== 0
        || event.metaKey
        || event.ctrlKey
        || event.shiftKey
        || event.altKey
    ) {
        return;
    }

    const grid = link.closest('[data-field-notes-grid]');

    if (!grid) {
        return;
    }

    const targetUrl = new URL(link.href, window.location.href);

    if (targetUrl.origin !== window.location.origin) {
        return;
    }

    event.preventDefault();

    refreshGrid(grid, targetUrl).then((nextGrid) => {
        if (nextGrid) {
            window.history.pushState({}, '', targetUrl.toString());

            if (link.closest('.field-notes-grid__pagination')) {
                scrollToSection(nextGrid);
            }
        } else {
            window.location.href = targetUrl.toString();
        }
    });
}

function handlePopState() {
    refreshAll(new URL(window.location.href));
}

function initialize() {
    if (!document.querySelector('[data-field-notes-grid]')) {
        return;
    }

    document.addEventListener('click', handleClick);
    window.addEventListener('popstate', handlePopState);
}

export default {
    initialize,
};
